import React from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import CustomInput from "../../Common/CustomInput";
import FileInput from "../../Common/FileInput";
import CustomSelect from "../../Common/CustomSelect";
import { surveyStatuses } from "../../../utils/surveys";
import { Button, Checkbox, Divider } from "antd";
import PagesList from "./PagesList/PagesList";
import { v4 as uuidv4 } from "uuid";
import ColorPicker from "../../Common/ColorPicker";
import TextAreaEditor from "../../Common/TextAreaEditor";

const QuestionsTab = ({ collapsedPage, setCollapsedPage }) => {
    const {
        control,
        formState: { errors },
        watch,
    } = useFormContext();

    const {
        append: appendPages,
        remove: removePage,
        move: movePage,
    } = useFieldArray({
        control,
        name: "pages",
    });

    const pagesArr = watch().pages;

    const addNewPageHandler = () => {
        appendPages({ id: uuidv4(), questions: [] });
    };

    const removePageHandler = (id) => {
        const pageIndex = pagesArr.findIndex((page) => page.id === id);
        if (pageIndex !== -1) {
            if (pagesArr.length < 2) {
                return;
            }
            removePage(pageIndex);
        }
    };

    return (
        <div
            style={{
                boxSizing: "border-box",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                gap: "20px",
                height: "93%",
                overflow: "auto",
            }}
        >
            <Controller
                control={control}
                name="name"
                render={({ field }) => (
                    <CustomInput errors={errors} label="Name *" {...field} />
                )}
            />
            <Controller
                control={control}
                name="isPublic"
                render={({ field }) => (
                    <Checkbox checked={!!field.value} {...field}>
                        Public
                    </Checkbox>
                )}
            />
            <Controller
                control={control}
                name="createProject"
                render={({ field }) => (
                    <Checkbox checked={!!field.value} {...field}>
                        Create Daylight project
                    </Checkbox>
                )}
            />
            <Controller
                control={control}
                name="image"
                render={({ field }) => (
                    <FileInput errors={errors} label="Image" {...field} />
                )}
            />
            <Controller
                control={control}
                name="description"
                render={({ field }) => (
                    <TextAreaEditor
                        errors={errors}
                        label="Description"
                        {...field}
                    />
                )}
            />
            <Controller
                control={control}
                name="status"
                render={({ field }) => (
                    <CustomSelect
                        style={{ width: "100%" }}
                        label="Status"
                        errors={errors}
                        allowClear
                        valueKey="value"
                        labelKey="label"
                        options={surveyStatuses}
                        {...field}
                    />
                )}
            />
            <Controller
                control={control}
                name="styling.background.bg"
                render={({ field }) => (
                    <ColorPicker
                        label="Background color"
                        errors={errors}
                        {...field}
                    />
                )}
            />
            <Controller
                control={control}
                name="productOverwrites.brandColor"
                render={({ field }) => (
                    <ColorPicker
                        label="Brand color"
                        errors={errors}
                        {...field}
                    />
                )}
            />

            <Divider />
            {pagesArr && pagesArr.length > 0 && (
                <PagesList
                    onDeletePage={removePageHandler}
                    pages={pagesArr}
                    move={movePage}
                    collapsedPage={collapsedPage}
                    setCollapsedPage={setCollapsedPage}
                />
            )}
            <div style={{ display: "flex" }}>
                <Button
                    size="middle"
                    type="primary"
                    onClick={addNewPageHandler}
                    style={{ fontWeight: 700 }}
                >
                    + Add page
                </Button>
            </div>
        </div>
    );
};

export default QuestionsTab;
